import * as React from 'react'
import ModalView from 'src/presentations/views/ModalView'
import TextInput from 'src/presentations/elements/TextInput'
import Button from 'src/presentations/elements/Button'
import { deleteInput, required } from 'src/utils/validations'
import { remove } from 'src/utils/graph/GraphExplorer'
import i18n from 'src/assets/messages'
import Props from './props'
import State from './state'
import * as SC from "./style"

class DeleteModal extends React.Component<Props, State> {
  public static defaultProps: Partial<Props> = {
    show: false,
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      value: '',
      error: false,
      submitted: false,
    }
  }

  /**
   * Update the value at each keystroke
   * @param {any} e - The event of the input value
   */
  onChange = (e: any) => {
    this.setState({ value: e.value, error: e.error })
  }

  /**
   * Comfirm the delete request after checking
   * The props will take over
   * @returns {() => void}
   */
  onSubmit = () => {
    if (!this.props.target && typeof this.props.onComfirm === 'function') {
      if (this.state.value === "SUPPRIMER") {
        return this.props.onComfirm()
      }
    }
    return this.setState({ submitted: true }, async () => {
      if (this.state.value === "SUPPRIMER") {
        await this.remove()
      }
    })
  }

  /**
   * Launch the request to remove the element
   * @return {void}
   */
  remove = async () => {
    if (!this.props.target) {
      return
    }
    try {
      const result: any = await remove({
        target: this.props.target,
        id: this.props.id,
        alias: 'row',
      })
      this.setState({ value: '', submitted: false, error: false }, () => {
        if (typeof this.props.onComfirm === 'function') {
          this.props.onComfirm(result.row)
        }
      })
      return result
    } catch (error) {
      this.setState({ value: '', submitted: false, error: false }, () => {
        if (typeof this.props.onComfirm === 'function') {
          this.props.onComfirm()
        }
      })
      return true
    }
  }

  /**
   * Display the header of the Modal
   * @return {any}
   */
  displayHeader = () => {
    return <span>{"Confirmation"}</span>
  }

  /**
   * Display content of the Modal
   * @return {any}
   */
  displayContent = () => {
    return (
      <TextInput
        validators={[
          { fn: required, msg: i18n.t('required') },
          { fn: deleteInput, msg: i18n.t('mustValueDelete') },
        ]}
        value={this.state.value}
        placeholder={"Entrez SUPPRIMER"}
        error={this.state.submitted}
        onChange={this.onChange}
        help={"Entrez SUPPRIMER pour supprimer définitivement"}
      />
    )
  }

  /**
   * Display footer of the modal
   * @return {any}
   */
  displayFooter = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          size="small"
          themeColor="light"
          type="button"
          label={"Annuler"}
          onClick={this.props.onHide}
        />
        <Button
          size="small"
          themeColor="primary"
          type="button"
          label={"Supprimer"}
          onClick={this.onSubmit}
        />
      </div>
    )
  }

  /**
   * Display main content
   * @returns {any}
   */
  render() {
    return (
      <SC.DeleteModal>
      <ModalView
        show={this.props.show}
        onHide={this.props.onHide}
        bsSize={'small'}
        dialogClassName={'modalClient'}
        header={this.displayHeader()}
        content={this.displayContent()}
        footer={this.displayFooter()}
      />
      </SC.DeleteModal>
    )
  }
}

export default DeleteModal



// WEBPACK FOOTER //
// ./src/presentations/widgets/DeleteModal/index.tsx